import React, { Component } from 'react';
import { Button, Form, Grid, Header, Icon, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import axios from 'axios';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from '../../util/PaginationFront';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';
import { HeaderCursor } from '../../Professor/ProfessorInputGrades/css';
import { fetchStudyCycle } from '../../Lookups/util';
import ReactExport from "react-data-export";
import ReportExcelFile from './ReportExcelFile';
import {
    additionalFilterSectionStyle,
    requiredFilterSectionStyle
} from './reportUiHelpers';

const ExcelFile = ReportExcelFile;
const { ExcelSheet } = ReactExport.ExcelFile;

class EnrolledAndPassedStudentsPerCourseByAcademicYear extends Component {
    state = {
        data: [],
        results: [],
        excelData: [],
        excelDataFilter: [],
        academicYear: null,
        orgUnit: null,
        studyProgramBasics: [],
        studyProgramBasicsAll: [],
        studyProgramBasicId: null,
        studyCycles: [],
        studyCycleId: null,
        activePage: 1,
        postsPerPage: 20,
        reportRequested: false,

        orgUnitFilter: !!(((localStorage.getItem('activeRole') || '').substr(0, 10) !== 'Studentska' &&
            (localStorage.getItem('activeRole') || '').substr(0, 19) !== 'Prodekan za nastavu')),
    };

    componentDidMount() {
        const orgUnit = localStorage.getItem('orgUnit');

        if (orgUnit) {
            this.setState({ orgUnit: parseInt(orgUnit) });
        }

        this.getAcademicYears();
        this.fetchStudyPrograms(orgUnit);

        fetchStudyCycle().then(res => {
            const studyCycles = res.data.map(el => ({ key: el.id, value: el.id, text: el.displayName }));
            this.setState({ studyCycles });
        });
    }

    fetchStudyPrograms = (selectedOrgUnit) => {
        const orgUnit = selectedOrgUnit || localStorage.getItem('orgUnit');

        if (this.state.orgUnitFilter && !orgUnit) {
            this.setState({ studyProgramBasics: [] });
            return;
        }

        const url = this.state.orgUnitFilter ? `study-programs/basic/${orgUnit}` : 'study-programs/basic';

        axios.post(url, {})
            .then(res => {
                const studyProgramBasics = res.data
                    .filter(e => !e.studyProgramBasic.archived)
                    .map(el => ({
                        ...el,
                        value: el.studyProgramBasic.id,
                        key: el.studyProgramBasic.id,
                        text: el.studyProgramBasic.name,
                        description: el.studyProgramBasic.studyCycles && el.studyProgramBasic.studyCycles.length > 0
                            ? el.studyProgramBasic.studyCycles[0].displayName
                            : ''
                    }));

                this.setState({ studyProgramBasics, studyProgramBasicsAll: studyProgramBasics });
            });
    }

    getAcademicYears = () => {
        axios.get('/academic-years/current-and-previous/')
            .then(res => {
                this.setState({
                    academicYears: res.data.map(el => ({
                        ...el,
                        key: el.id,
                        value: el.id,
                        text: el.name
                    })).reverse()
                });
            });
    }

    handleInputChange = (e, { name, value }) => {
        if (name === 'orgUnit') {
            this.setState({
                orgUnit: value,
                academicYear: null,
                studyCycleId: null,
                data: [],
                results: [],
                excelData: [],
                excelDataFilter: [],
                studyProgramBasicId: null,
                reportRequested: false,
            });
            this.fetchStudyPrograms(value);
            return;
        }

        this.setState({ [name]: value });

        if (name === 'academicYear' || name === 'studyProgramBasicId') {
            this.setState({ data: [], results: [], excelData: [], excelDataFilter: [], reportRequested: false });
        }

        if (name === 'studyCycleId') {
            this.setState({
                studyProgramBasicId: null,
                studyProgramBasics: value === null || value === ''
                    ? this.state.studyProgramBasicsAll
                    : this.state.studyProgramBasicsAll.filter(el =>
                        el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].id === value : false)
            });
        }
    }

    getData = (studyProgramBasicId, academicYear = this.state.academicYear) => {
        if (!academicYear || (this.state.orgUnitFilter && !this.state.orgUnit)) {
            this.setState({ loader: false });
            return;
        }

        this.setState({ loader: true, reportRequested: true });

        axios.get(
            this.state.orgUnitFilter
                ? `/exams/course-statistics-for-admin/${academicYear}/${this.state.orgUnit}/${studyProgramBasicId}`
                : `/exams/course-statistics/${academicYear}/${studyProgramBasicId}`
        )
            .then(res => {
                const data = res.data.map(el => ({
                    courseBasicName: el.courseBasicName,
                    courseBasicComment: el.courseBasicComment,
                    professor: el.professor,
                    numberOfStudentsOnCourse: el.numberOfStudentsOnCourse,
                    numberOfStudentsWhoPassed: el.numberOfStudentsWhoPassed,
                    numberOfStudentsWhoFailed: el.numberOfStudentsOnCourse - el.numberOfStudentsWhoPassed,
                }));

                const excelData = data.map(el => ([
                    { value: el.courseBasicName },
                    { value: el.courseBasicComment },
                    { value: el.professor },
                    { value: el.numberOfStudentsOnCourse },
                    { value: el.numberOfStudentsWhoPassed },
                    { value: el.numberOfStudentsWhoFailed },
                ]));

                this.setState({ data, excelData, loader: false, results: [] });
            })
            .catch(err => {
                console.log('Failed to fetch course statistics by academic year.', err);
                this.setState({ data: [], excelData: [], loader: false, results: [], reportRequested: true });
            });
    }

    getResults = (results) => {
        const excelDataFilter = results.map(el => ([
            { value: el.courseBasicName },
            { value: el.courseBasicComment },
            { value: el.professor },
            { value: el.numberOfStudentsOnCourse },
            { value: el.numberOfStudentsWhoPassed },
            { value: el.numberOfStudentsWhoFailed },
        ]));

        this.setState({ results, excelDataFilter, activePage: 1 });
    }

    getDataToRender = () => this.state.results.length ? this.state.results : this.state.data;

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage });

    render() {
        const { academicYear, data, loader, activePage, postsPerPage, results, excelData, excelDataFilter, reportRequested } = this.state;

        const multiDataSet = [{
            columns: [
                { title: 'Predmet', width: { wpx: 300 } },
                { title: 'Napomena', width: { wpx: 100 } },
                { title: 'Nastavnik/ica', width: { wpx: 200 } },
                { title: 'Broj studenata koji pohađaju predmet - n', width: { wpx: 250 } },
                { title: 'Broj studenata koji su položili ispit - k', width: { wpx: 250 } },
                { title: 'Broj studenata koji nisu položili', width: { wpx: 250 } },
            ],
            data: results.length === 0 ? excelData : excelDataFilter,
        }];

        const currentPosts = this.getDataToRender()
            .slice((activePage - 1) * postsPerPage, activePage * postsPerPage);

        return (
            <div>
                <Form>
                    <Segment style={requiredFilterSectionStyle}>
                        <Header as="h4" color="blue">Obavezni parametri</Header>
                        <Form.Group widths="equal">
                            {this.state.orgUnitFilter && <Form.Field>
                                <Form.Dropdown
                                    clearable
                                    label="Organizaciona jedinica"
                                    value={this.state.orgUnit}
                                    onChange={this.handleInputChange}
                                    name="orgUnit"
                                    options={this.props.organizationalUnits}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>}
                            <Form.Field>
                                <label>Akademska godina</label>
                                <Form.Dropdown
                                    value={academicYear}
                                    onChange={this.handleInputChange}
                                    name="academicYear"
                                    options={this.state.academicYears}
                                    search
                                    fluid
                                    selection
                                    disabled={this.state.orgUnitFilter && !this.state.orgUnit}
                                />
                            </Form.Field>
                            <Form.Field />
                        </Form.Group>
                    </Segment>

                    <Segment style={additionalFilterSectionStyle}>
                        <Header as="h4" color="blue">Dodatni filteri</Header>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <Form.Dropdown
                                    label="Ciklus studija"
                                    clearable
                                    placeholder="Odaberite ciklus"
                                    options={this.state.studyCycles}
                                    onChange={this.handleInputChange}
                                    name="studyCycleId"
                                    value={this.state.studyCycleId}
                                    search
                                    fluid
                                    selection
                                    disabled={!this.state.academicYear || (this.state.orgUnitFilter && !this.state.orgUnit)}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown
                                    label="Studijski program"
                                    clearable
                                    placeholder="Odaberite studijski program"
                                    options={this.state.studyProgramBasics}
                                    onChange={this.handleInputChange}
                                    name="studyProgramBasicId"
                                    value={this.state.studyProgramBasicId}
                                    search
                                    fluid
                                    selection
                                    disabled={!this.state.academicYear || (this.state.orgUnitFilter && !this.state.orgUnit)}
                                />
                            </Form.Field>
                        </Form.Group>
                    </Segment>
                    <Button
                        basic="true"
                        color="blue"
                        floated="right"
                        onClick={this.props.closeReport}
                        disabled={!this.state.academicYear || (this.state.orgUnitFilter && !this.state.orgUnit)}
                    >
                        Odustani
                    </Button>
                    <Button
                        color="blue"
                        floated="right"
                        onClick={() => this.getData(this.state.studyProgramBasicId || 0)}
                        disabled={!this.state.academicYear || (this.state.orgUnitFilter && !this.state.orgUnit)}
                    >
                        Prikaži izvještaj
                    </Button>
                </Form>

                <br /><br /><br />

                {reportRequested && academicYear && (
                    loader ? <Loader active inline="centered" /> :
                        <div>
                            {data.length === 0 ? 'Nema podataka!' : (
                                <Table celled selectable compact size="small">
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan={16}>
                                                <Grid columns={2}>
                                                    <Grid.Column width={14}>
                                                        <SearchTableData
                                                            profMozilla
                                                            data={data}
                                                            getResults={this.getResults}
                                                            filterItem={[
                                                                'courseBasicName',
                                                                'professor',
                                                                'numberOfStudentsOnCourse',
                                                                'numberOfStudentsWhoPassed'
                                                            ]}
                                                        />
                                                    </Grid.Column>
                                                    <Grid.Column width={2}>
                                                        <ExcelFile filename="Prolaznost" element={
                                                            <Button color='green' basic fluid>
                                                                Excel
                                                            </Button>
                                                        }>
                                                            <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Broj studenata" />
                                                        </ExcelFile>
                                                    </Grid.Column>
                                                </Grid>
                                            </Table.HeaderCell>
                                        </Table.Row>

                                        <Table.Row>
                                            <Table.HeaderCell colSpan={4}>Predmet
                                                <span style={{ color: '#a6a4a1' }}><br/>Napomena</span></Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>Nastavnik</Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>Upisani studenti na predmet</Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>Studenti koji su položili</Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>Studenti koji nisu položili</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>

                                    <Table.Body>
                                        {currentPosts.map((el, index) => (
                                            <Table.Row key={index} style={HeaderCursor}>
                                                <Table.Cell colSpan={4}>
                                                    {(index + 1) + ((activePage - 1) * postsPerPage)}. {el.courseBasicName}
                                                    <span style={{ color: '#a6a4a1' }}><br/>{el.courseBasicComment ? el.courseBasicComment : ''}</span>
                                                </Table.Cell>
                                                <Table.Cell colSpan={3}>{el.professor}</Table.Cell>
                                                <Table.Cell colSpan={3}>{el.numberOfStudentsOnCourse}</Table.Cell>
                                                <Table.Cell colSpan={3}>{el.numberOfStudentsWhoPassed}</Table.Cell>
                                                <Table.Cell colSpan={3}>{el.numberOfStudentsWhoFailed}</Table.Cell>
                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table>
                            )}

                            {currentPosts.length > 0 && (
                                <PaginationFront
                                    postsPerPage={postsPerPage}
                                    totalPosts={this.getDataToRender().length}
                                    paginate={this.handlePaginationChange}
                                    activePage={activePage}
                                />
                            )}
                        </div>
                )}
            </div>
        );
    }
}

export default EnrolledAndPassedStudentsPerCourseByAcademicYear;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/EnrolledAndPassedStudentsPerCourseByAcademicYear.js